export default __webpack_public_path__ + "static/media/logo.cf019013.png";